import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { toast } from 'sonner';
import '@splidejs/splide/dist/css/splide.min.css';
import App from 'app';
import reportWebVitals from './reportWebVitals';
import './styles/global.scss';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DNS,
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.5
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);

// Handle global errors outside of the React cycle
window.addEventListener('error', event => {
  const message = (event?.error as Error)?.message || event.message || 'Unknown error';
  toast.error(message);
});

window.addEventListener('unhandledrejection', event => {
  const message = (event?.reason as Error)?.message || 'Unhandled promise rejection';
  toast.error(message);
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
